module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2I2MDAwMDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmV4Y2xhbWF0aW9uPC90aXRsZT48cGF0aCBjbGFzcz0iYSIgZD0iTTIxLDE3LjEybDEuNiwxMy4xaDIuODZMMjcsMTcuMTJWMTBIMjF2Ny4xMmgwWk0yMS4xMywzOGg1LjczVjMyLjQ5SDIxLjEzVjM4Wk0yNCw0QTIwLDIwLDAsMSwxLDQsMjQsMjAsMjAsMCwwLDEsMjQsNG0wLTRBMjQsMjQsMCwxLDAsNDgsMjQsMjQsMjQsMCwwLDAsMjQsMGgwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/exclamation.svg
// module id = 2K5i
// module chunks = 0